import React from 'react';

// Tair wordmark with a luminous dot above the "i" representing "bringing light"
export const TairLogo = ({ className = '', textClassName = '', size = 'md', showSub = false, dotTestId = 'tair-logo-dot' }) => {
  const sizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl md:text-5xl',
    xl: 'text-6xl md:text-7xl lg:text-8xl',
  };

  return (
    <div className={`inline-flex items-center ${className}`} data-testid="tair-logo">
      <div className="relative inline-flex items-baseline">
        <span className={`font-display font-extrabold tracking-tight text-white ${sizes[size]} ${textClassName}`}>
          ta
        </span>
        <span className={`relative font-display font-extrabold tracking-tight text-white ${sizes[size]} ${textClassName}`}>
          {/* the "i" without its dot */}
          <span className="inline-block" style={{ transform: 'translateY(0)' }}>ı</span>
          {/* luminous dot */}
          <span
            data-testid={dotTestId}
            className="tair-dot absolute rounded-full bg-amber-400"
            style={{
              width: '0.22em',
              height: '0.22em',
              top: size === 'xl' ? '-0.05em' : size === 'lg' ? '-0.02em' : '0em',
              left: '50%',
              transform: 'translateX(-50%)',
              boxShadow: '0 0 12px rgba(224,168,32,0.95), 0 0 28px rgba(224,168,32,0.6)',
            }}
          />
        </span>
        <span className={`font-display font-extrabold tracking-tight text-white ${sizes[size]} ${textClassName}`}>
          r
        </span>
      </div>
      {showSub && (
        <span className="ml-3 hidden sm:inline-flex items-center gap-2 pl-3 border-l border-white/15 text-[11px] tracking-[0.18em] text-white/55" style={{ fontVariant: 'small-caps' }}>
          <span className="uppercase">Inversiones&nbsp;·&nbsp;</span><span>SpA</span>
        </span>
      )}
    </div>
  );
};

export default TairLogo;
